import { render, staticRenderFns } from "./EmailAttachmentsEmailCompose.vue?vue&type=template&id=38f81ea5&scoped=true"
import script from "./EmailAttachmentsEmailCompose.vue?vue&type=script&lang=js"
export * from "./EmailAttachmentsEmailCompose.vue?vue&type=script&lang=js"
import style0 from "./EmailAttachmentsEmailCompose.vue?vue&type=style&index=0&id=38f81ea5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f81ea5",
  null
  
)

export default component.exports